import styles from "./Tag.module.sass";
import { Close } from "@platzi/icons";

interface Props {
  tag: string;
  handleTagRemove: (tag: string) => void;
}

export const Tag = ({ tag, handleTagRemove }: Props) => {
  return (
    <div className={styles.Tag}>
      {tag}
      <button className="remove-button" onClick={() => handleTagRemove(tag)}>
        <Close />
      </button>
    </div>
  );
};
